import styled from 'styled-components'

import Button from '../Button/Button'

const RedoSearchButton = styled(Button)`
  position: absolute;
  top: 15px;
  left: calc(15px + 29px + 15px);
  height: 29px;

  border: 2px;
  border-radius: 4px;
`

export default RedoSearchButton
